import { AppHeader, Box, Container, Stack, Typography } from '@ace-clublabs/shared-component-library';
import { LoadingView } from '../components/LoadingView/LoadingView';
import { useEffect, useRef, useState } from 'react';
import { sources } from '../api/sources';
import { useGlobalState } from '../state/state';
import { UpdateMembershipStatus as UpdateMembershipStatuses } from '@lib/types';
import { useHistory } from 'react-router-dom';
import { Pages, SESSION_EXPIRED_STATUS_CODES } from '../utils/constants';

// total: one minute
export const RETRY_INTERVAL = 3000;
const MAX_RETRIES = 20;

export const UpdateMembershipStatus: React.FC = () => {
  const history = useHistory();
  const [memberDetails] = useGlobalState('memberDetails');
  const [_, setConfirmation] = useGlobalState('confirmation');
  const { sessionId } = memberDetails;
  const [finishLoadingProps, setFinishLoadingProps] = useState({
    finished: false,
    onFinish: () => {},
  });

  let retries = 0;

  const getConfirmation = async () => {
    try {
      const { data } = await sources.getConfirmation({ sessionId: sessionId! });
      setConfirmation(data);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const navigateToConfirmationPage = () => history.push(Pages.ConfirmationPage);
  const navigateToSorryPage = () => history.push(Pages.SorryPage);
  const navigateToPaymentErrorPage = () => history.push(Pages.PaymentError);
  const navigateToTimeoutErrorPage = () => history.push(Pages.TimeoutError);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        retries++;
        const { status } = await sources.getMembershipStatus({ sessionId: sessionId! });

        const latestStatus = (status as UpdateMembershipStatuses[]).pop();

        // console.log('retry', retries);
        if (latestStatus === UpdateMembershipStatuses.COMPLETED) {
          clearInterval(interval);
          await getConfirmation();
          setFinishLoadingProps({ finished: true, onFinish: navigateToConfirmationPage });
        } else if (latestStatus === UpdateMembershipStatuses.PAYMENT_FAILED) {
          throw Error('PAYMENT_FAILED');
        } else if (latestStatus === UpdateMembershipStatuses.FAILED) {
          throw Error('FAILED');
        } else if (retries >= MAX_RETRIES) {
          throw Error('TIMEOUT');
        }
      } catch (e: any) {
        console.error(e);
        let navigateOnFinishError = navigateToSorryPage;
        if (e instanceof Error && e.message === UpdateMembershipStatuses.PAYMENT_FAILED) {
          navigateOnFinishError = navigateToPaymentErrorPage;
        } else if (SESSION_EXPIRED_STATUS_CODES.includes(e?.error?.code)) {
          navigateOnFinishError = navigateToTimeoutErrorPage;
        }

        setFinishLoadingProps({ finished: true, onFinish: navigateOnFinishError });
      }
    }, RETRY_INTERVAL);

    return () => clearInterval(interval);
  }, []);

  return <LoadingView estimatedTimeInSeconds={20} message="Completing your payment" finishProps={finishLoadingProps} />;
};
